'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _user = require('./user/user');

var _user2 = _interopRequireDefault(_user);

var _auth = require('./auth/auth');

var _auth2 = _interopRequireDefault(_auth);

var _loki = require('./services/loki.factory');

var _loki2 = _interopRequireDefault(_loki);

var _api = require('./services/api');

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_user2.default, _auth2.default]).factory('db', _loki2.default).service("Api", _api2.default).name;

exports.default = commonModule;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/common/common.js
 **/